// extracted by mini-css-extract-plugin
module.exports = {"visible":"visible__wHXGN","bff-show":"bff-show__3x9+E","h6":"h6__fswDe","p":"p__SNm2w","bff-tool-tip":"bff-tool-tip__1Rqec","noMargin":"noMargin__8oizD","tooltip":"tooltip__KwdUk"};